module.exports = __webpack_public_path__ + "static/media/3DPPA24.086dcda4.jpg";